import { render, staticRenderFns } from "./answerList.vue?vue&type=template&id=6d07c092&scoped=true"
import script from "./answerList.vue?vue&type=script&lang=js"
export * from "./answerList.vue?vue&type=script&lang=js"
import style0 from "./answerList.vue?vue&type=style&index=0&id=6d07c092&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d07c092",
  null
  
)

export default component.exports